/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line
  document.addEventListener('theme:cart:change', (e) => {
    const { detail: { cartCount } } = e;
    cart.cart.classList.toggle('is-empty', cartCount === 0)

    if (cartCount > 0) {
      fetchUpsell()
      updateAddToCartButtons()
    } else {
      document.querySelectorAll('.is-in-cart').forEach(button => {
        button.classList.remove('is-in-cart')
        updateButtonText(button, false)
      })

      const cartBarButton = document.querySelector('[data-add-to-cart-bar]');
      if (cartBarButton) {
        const textElement = cartBarButton.querySelector('.btn__text');
        if (textElement && textElement.getAttribute('data-original-text')) {
          textElement.textContent = textElement.getAttribute('data-original-text');
          textElement.removeAttribute('data-original-text');
        }
      }
    }
  })

  function fetchUpsell() {
    fetch(theme.routes.cart_url + '?section_id=api-dynamic-upsell')
      .then(cart.cartErrorsHandler)
      .then((response) => response.text())
      .then((response) => {
        const element = document.createElement('div');
        element.innerHTML = response;
        const oldUpsell = document.querySelector('.cart-upsell-container');
        const newUpsell = element.querySelector('.cart-upsell-container');
        oldUpsell.innerHTML = newUpsell.innerHTML
       })
      .catch((error) => console.log(error));
  }

  document.addEventListener('DOMContentLoaded', function () {

    // Read more component
    class ReadMore extends HTMLElement {
      constructor() {
        super();
        this.readMoreText = this.dataset.readMoreText;
        this.readLessText = this.dataset.readLessText;
        this.contentWrapper = this.querySelector('.read-more-wrapper');
        this.textTruncated = this.querySelector('.read-more-truncated');
        this.textFull = this.querySelector('.read-more-full');
        this.button = document.createElement('button');
        this.button.classList.add('read-more-button');
        this.button.innerHTML = this.readMoreText;
        this.buttonHeight = this.button.offsetHeight;
        this.fullTextHeight = 0;
      }

      connectedCallback() {
        this.truncatedTextHeight = this.textTruncated.offsetHeight;
        this.contentWrapper.style.height = this.truncatedTextHeight + 'px';
        this.appendChild(this.button);
        this.button.addEventListener('click', this.toggleContent.bind(this));
      }

      toggleContent() {
        if (!this.contentWrapper.classList.contains('expanded')) {
          this.showFullText();
        } else {
          this.showTruncatedText();
        }
      }

      showFullText() {
        console.log(this.contentWrapper)
        this.textFull.classList.remove('hidden');
        this.textTruncated.classList.add('hidden');
        if (this.fullTextHeight === 0) {
          this.fullTextHeight = this.textFull.offsetHeight + this.buttonHeight;
        }
        this.contentWrapper.style.height = this.fullTextHeight + 'px';

        this.contentWrapper.classList.add('expanded');
        this.button.innerText = this.readLessText;
      }

      showTruncatedText() {
        this.textFull.classList.add('hidden');
        this.textTruncated.classList.remove('hidden');

        this.textTruncated.offsetHeight;

        const currentTruncatedHeight = this.textTruncated.offsetHeight;

        const heightToUse = currentTruncatedHeight > 0 ? currentTruncatedHeight : this.truncatedTextHeight;

        this.contentWrapper.style.height = heightToUse + 'px';
        this.contentWrapper.classList.remove('expanded');
        this.button.innerText = this.readMoreText;

        const closestTeamMember = this.closest('.meet-team__member');
        if (closestTeamMember) {
          const elementPosition = closestTeamMember.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - 100,
            behavior: 'smooth'
          });
        }
      }
    }

    if (!window.customElements.get("read-more")) {
      window.customElements.define("read-more", ReadMore);
    }

  });

  // Product in article
  const articleProducts = document.querySelector('.article-products-wrapper-outer');
  const articleContent = document.querySelector('.article__content');

  if (articleProducts && articleContent) {
    const targetDiv = articleContent.querySelector('#articleProducts');
    if (targetDiv) {
      targetDiv.innerHTML = articleProducts.innerHTML;
      articleProducts.remove();
    }
  }

  // American language icon
  const tLabContainer = document.querySelector('.header__desktop__button.t-localization');
  if (tLabContainer) {
    const tLabForm = tLabContainer.querySelector('.shopify-localization-form');
    if (tLabForm) {
      const languageInput = tLabForm.querySelector('input[name="language_code"]');
      if (languageInput) {
        const language = languageInput.value;

        const imageToBeReplaced = tLabForm.querySelector('.tl-flag');
        const americanFlag = document.getElementById('american_flag');
        let americanFlagUrl;
        if (americanFlag) {
          americanFlagUrl = americanFlag.value;
        }

        const dropDown = tLabForm.querySelector('ul.tl-options');
        if (dropDown) {
          const englishOption = dropDown.querySelector('li.tl-option[data-value="en"]');
          if (englishOption) {
            const englishOptionImage = englishOption.querySelector('img');

            if (language === 'en' && americanFlagUrl && imageToBeReplaced && englishOptionImage) {
              imageToBeReplaced.src = americanFlagUrl;
              englishOptionImage.src = americanFlagUrl;
            }
          }
        }
      }
    }
  }

  const tLabMobileContainer = document.querySelector('.header__mobile__button.mobile-t-localization');
  if (tLabMobileContainer) {
    const tLabMobileForm = tLabMobileContainer.querySelector('.shopify-localization-form');
    if (tLabMobileForm) {
      const mobileLanguageInput = tLabMobileForm.querySelector('input[name="language_code"]');
      if (mobileLanguageInput) {
        const mobileLanguage = mobileLanguageInput.value;

        const mobileImageToBeReplaced = tLabMobileForm.querySelector('.tl-flag');
        const americanFlag = document.getElementById('american_flag');
        let americanFlagUrl;
        if (americanFlag) {
          americanFlagUrl = americanFlag.value;
        }

        const tLabMobileDropDown = tLabMobileForm.querySelector('ul.tl-options');
        if (tLabMobileDropDown) {
          const tLabMobileEnglishOption = tLabMobileDropDown.querySelector('li.tl-option[data-value="en"]');
          if (tLabMobileEnglishOption) {
            const tLabMobileEnglishOptionImage = tLabMobileEnglishOption.querySelector('img');

            if (mobileLanguage === 'en' && americanFlagUrl && mobileImageToBeReplaced && tLabMobileEnglishOptionImage) {
              mobileImageToBeReplaced.src = americanFlagUrl;
              tLabMobileEnglishOptionImage.src = americanFlagUrl;
            }
          }
        }
      }
    }
  }

  //Express checkout button
  const atcInstantButton = document.querySelector('.btn.btn-primary.btn-instant-add');

  atcInstantButton?.addEventListener('click', function(event) {
    event.preventDefault();

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })

    .then(response => response.json())

    .then(data => {
      const productForm = atcInstantButton.closest('form');
      const productFormData = new FormData(productForm);

      fetch('/cart/add.js', {
        method: 'POST',
        body: productFormData,
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(response => response.json())
      .then(data => {
        window.location.href = '/checkout';
      });
    });
  });

  //FAQ page rich snippet
  if (!window.faqSchemaGenerated) {
    window.faqSchemaGenerated = true;

    document.addEventListener('DOMContentLoaded', function() {
      const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": []
      };

      const accordionGroups = document.querySelectorAll('.accordion-group');

      if (accordionGroups.length > 0) {
        accordionGroups.forEach(group => {
          if (group.hasAttribute('data-exclude-from-schema')) {
            return;
          }

          const questions = group.querySelectorAll('details.accordion');

          questions.forEach(details => {
            const summary = details.querySelector('summary.accordion__title');
            const answerDiv = details.querySelector('.accordion__content');

            if (summary && answerDiv) {
              const summaryClone = summary.cloneNode(true);
              summaryClone.querySelectorAll('.icon__animated, .icon-plus, .icon-minus').forEach(el => el.remove());

              const questionText = summaryClone.innerText.trim().replace(/\s+/g, ' ');
              const answerText = answerDiv.textContent.trim().replace(/\s+/g, ' ');

              if (questionText && answerText) {
                faqSchema.mainEntity.push({
                  "@type": "Question",
                  "name": questionText,
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": answerText
                  }
                });
              }
            }
          });
        });

        if (faqSchema.mainEntity.length > 0) {
          const scriptTag = document.createElement('script');
          scriptTag.type = 'application/ld+json';
          scriptTag.textContent = JSON.stringify(faqSchema, null, 2);
          document.head.appendChild(scriptTag);
        }
      }
    });
  }

  /* to close the Searchanise app popup */
  document.addEventListener('click', function(event) {
    const resultsContainer = document.querySelector('.snize-ac-results-content');
    if (resultsContainer && getComputedStyle(resultsContainer).display !== 'none') {
      if (!resultsContainer.contains(event.target)) {
        resultsContainer.style.display = 'none';
      }
    }
  });

  /* ATC buttons text change when added to cart */
  function updateButtonText(button, isInCart) {
    const textElement = button.querySelector('.btn-add-text') || button.querySelector('.btn__text');
    if (!textElement) return;

    const addMoreTextInput = document.querySelector('[data-add-more-text]');
    const addMoreText = addMoreTextInput ? addMoreTextInput.getAttribute('data-add-more-text') : 'Add more to cart';
    const addMoreTextShort = addMoreTextInput ? addMoreTextInput.getAttribute('data-add-more-text-short') : 'Add';

    if (isInCart && textElement.textContent !== addMoreText) {
      if (!textElement.getAttribute('data-original-text')) {
        textElement.setAttribute('data-original-text', textElement.textContent);
      }
      let addToCartHTML = `<span class="small-hide medium-hide">${addMoreText}</span><span class="large-up-hide">${addMoreTextShort}</span>`;
      textElement.innerHTML = addToCartHTML;
    } else if (!isInCart && textElement.getAttribute('data-original-text')) {
      textElement.textContent = textElement.getAttribute('data-original-text');
      textElement.removeAttribute('data-original-text');
    }
  }

  function updateAddToCartButtons() {
    document.querySelectorAll('.is-in-cart').forEach(button => {
      updateButtonText(button, true);
    });

    fetch(theme.routes.cart_url + '.js')
      .then(response => response.json())
      .then(cart => {
        const cartProductIds = new Set(cart.items.map(item => item.product_id));
        const cartVariantIds = new Set(cart.items.map(item => item.variant_id));

        document.querySelectorAll('.btn-add').forEach(button => {
          const form = button.closest('form');
          if (!form) return;

          const productId = form.dataset.productId;
          const variantInput = form.querySelector('input[name="id"]');
          const variantId = variantInput ? Number(variantInput.value) : null;

          const isInCart = (productId && cartProductIds.has(Number(productId))) ||
                          (variantId && cartVariantIds.has(Number(variantId)));

          button.classList.toggle('is-in-cart', isInCart);
          updateButtonText(button, isInCart);
        });

        const cartBarButton = document.querySelector('[data-add-to-cart-bar]');
        if (cartBarButton) {
          const productId = document.querySelector('[data-product-json]')?.textContent;
          if (productId) {
            const productData = JSON.parse(productId);
            const currentVariantId = document.querySelector('input[name="id"]')?.value;

            const isInCart = (productData.id && cartProductIds.has(Number(productData.id))) || (currentVariantId && cartVariantIds.has(Number(currentVariantId)));

            cartBarButton.classList.toggle('is-in-cart', isInCart);
            updateButtonText(cartBarButton, isInCart);
          }
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (cart && cart.cart && !cart.cart.classList.contains('is-empty')) {
      document.querySelectorAll('.is-in-cart').forEach(button => {
        updateButtonText(button, true);
      });

      updateAddToCartButtons();
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

})();

class ReadMoreLess extends HTMLElement {
  constructor(){
    super();
    this.readMoreLessButton = this.querySelector('.read-more-less-button');
    this.content = this.querySelector('.content');
    this.mobileHeight = this.dataset.mobileHeight;
    this.desktopHeight = this.dataset.desktopHeight;
    this.tabletHeight = this.dataset.desktopHeight;
    this.isFullHeight = false;
  }

  connectedCallback() {
    if (window.innerWidth <= 989) {
      this.content.style.height = this.mobileHeight + 'px';
    } else if(window.innerWidth >= 990 && window.innerWidth <= 1025) {
      this.content.style.height = this.tabletHeight + 'px';
    } else {
      this.content.style.height = this.desktopHeight + 'px';
    }

    this.readMoreLessButton.addEventListener('click', this.setHeight.bind(this));
    window.addEventListener('resize', this.updateResizeHeight.bind(this));
  }

  disconnectedCallback() {
    this.readMoreLessButton.removeEventListener('click', this.setHeight);
    window.removeEventListener('resize', this.updateResizeHeight);
  }

  updateResizeHeight() {
    if (this.isFullHeight) {
      let newHeight = this.content.scrollHeight;
      this.content.style.height = newHeight + 'px';
    }
    else {
      if (window.innerWidth <= 989) {
        this.content.style.height = this.mobileHeight + 'px';
      } else if(window.innerWidth >= 990 && window.innerWidth <= 1025) {
        this.content.style.height = this.tabletHeight + 'px';
      } else {
        this.content.style.height = this.desktopHeight + 'px';
      }
    }
  }

  updateButtonText(text) {
    this.readMoreLessButton.innerHTML = text;
  }

  setHeight() {
    if(this.isFullHeight) {
      if (window.innerWidth <= 989) {
        this.content.style.height = this.mobileHeight + 'px';
      } else if(window.innerWidth >= 990 && window.innerWidth <= 1025) {
        this.content.style.height = this.tabletHeight + 'px';
      } else {
        this.content.style.height = this.desktopHeight + 'px';
      }
      this.isFullHeight = false;
      this.updateButtonText('Read more');
    } else {
      let newHeight = this.content.scrollHeight;
      this.content.style.height = newHeight + 'px';
      this.isFullHeight = true;
      this.updateButtonText('Read less');
    }
  }
}

if (!window.customElements.get("read-more-less")) {
  window.customElements.define("read-more-less", ReadMoreLess );
}


// header dropdown menus calculation to not go out of bounds
document.querySelectorAll('.header__desktop__bar__c_item_wrapper').forEach(headerItem => {
  headerItem.addEventListener('mouseenter', () => {
    const headerDropdown = headerItem.querySelector('.header__desktop__bar__c_item_dropdown');
    if (!headerDropdown) return;
    headerDropdown.style.left = '0';
    headerDropdown.style.right = 'auto';
    if (headerDropdown.getBoundingClientRect().right > window.innerWidth) {
      headerDropdown.style.left = 'auto';
      headerDropdown.style.right = '0';
    }
  });
});